export const GLOBAL_PERIOD_STORAGE_KEY = 'global_period';
export const GLOBAL_PERIOD_EVENT = 'global-period-changed';

const PERIOD_REGEX = /^(\d{4})(-(0[1-9]|1[0-2]))?$/;

const getCurrentMonthPeriod = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export const normalizeGlobalPeriod = (period) => {
  const value = String(period || '').trim();
  return PERIOD_REGEX.test(value) ? value : '';
};

export const getGlobalPeriod = () => {
  const stored = normalizeGlobalPeriod(localStorage.getItem(GLOBAL_PERIOD_STORAGE_KEY));

  if (stored) {
    return stored;
  }

  const fallback = getCurrentMonthPeriod();
  localStorage.setItem(GLOBAL_PERIOD_STORAGE_KEY, fallback);
  return fallback;
};

export const setGlobalPeriod = (period) => {
  const normalized = normalizeGlobalPeriod(period) || getCurrentMonthPeriod();
  const previous = normalizeGlobalPeriod(localStorage.getItem(GLOBAL_PERIOD_STORAGE_KEY));

  localStorage.setItem(GLOBAL_PERIOD_STORAGE_KEY, normalized);

  window.dispatchEvent(new CustomEvent(GLOBAL_PERIOD_EVENT, {
    detail: {
      period: normalized,
      previousPeriod: previous,
    },
  }));

  return normalized;
};
